// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__38VxN","left":"StickyBox_left__2-OSL","right":"StickyBox_right__3vurE"};